<template>
    <span class="control-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88">
            <template v-if="paused">
                <defs>
                    <filter id="xewfzuedra" width="145.8%" height="145.8%" x="-21.9%" y="-21.9%" filterUnits="objectBoundingBox">
                        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
                        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                </defs>
                <g fill="none" fill-rule="evenodd" filter="url(#xewfzuedra)" transform="translate(20 20)">
                    <path fill="#FFF" d="M20.416 20.571l7.357 7.357v.055c0 1.104-.895 2-2 2h-8.1c-1.104 0-2-.896-2-2V22.57c0-1.104.896-2 2-2h2.743zm5.358 0c1.104 0 2 .896 2 2v3.278l-5.279-5.278h3.279zM28.768 23.718c0-.818.497-1.553 1.257-1.857l.983-.393c.838-.335 1.79.072 2.124.91.077.193.117.399.117.607v4.584c0 .903-.731 1.634-1.634 1.634-.206 0-.41-.039-.602-.115l-2.245-2.244v-3.126z"/>
                    <circle cx="24.137" cy="24.333" r="23.51" stroke="#FFF"/>
                    <path fill="#FFF" d="M23 1L24.469 1 24.469 48.7 23 48.7z" transform="rotate(-45 23.735 24.85)"/>
                </g>
            </template>
            <template v-else>
                <defs>
                    <filter id="tngmlv7kla" width="145.8%" height="145.8%" x="-21.9%" y="-21.9%" filterUnits="objectBoundingBox">
                        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
                        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                </defs>
                <g fill="none" fill-rule="evenodd" filter="url(#tngmlv7kla)" transform="translate(20 20)">
                    <g>
                        <rect width="12.1" height="9.411" x="15.673" y="20.571" fill="#FFF" rx="3"/>
                        <path fill="#FFF" d="M30.025 21.861l.983-.393c.838-.335 1.79.072 2.124.91.077.193.117.399.117.607v4.584c0 .903-.731 1.634-1.634 1.634-.208 0-.414-.04-.607-.117l-.983-.393c-.76-.304-1.257-1.04-1.257-1.857v-3.118c0-.818.497-1.553 1.257-1.857z"/>
                        <circle cx="24.137" cy="24.333" r="23.51" stroke="#FFF"/>
                    </g>
                </g>
            </template>
        </svg>
        <i>
            {{ paused ? 'Start video' : 'Pause video'}}
        </i>
    </span>
    
</template>

<script>
export default {
    name: 'video-icon',

    props: {
        paused: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>